import { render } from "./EmergencyTable.vue?vue&type=template&id=4f90d0c2&scoped=true&ts=true"
import script from "./EmergencyTable.ts?vue&type=script&lang=ts"
export * from "./EmergencyTable.ts?vue&type=script&lang=ts"

import "./EmergencyTable.scss?vue&type=style&index=0&id=4f90d0c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f90d0c2"]])

export default __exports__